import type { DataSourceEntity } from '@unifyapps/defs/types/dataSource';
import { useSnackbar } from '@unifyapps/ui/components/Snackbar';
import { useCallback } from 'react';
import DataSourceHelper from '../../../helper/DataSourceHelper';

function useShowDisabledDataSourceSnackbar(
  getDataSourceRecord: (dataSourceId: string) => DataSourceEntity | undefined,
) {
  const { showSnackbar } = useSnackbar();

  const showDisabledDSMessage = useCallback(
    (dataSourceId: string) => {
      const disabledQueryMessage = DataSourceHelper.advancedOptions(
        getDataSourceRecord(dataSourceId),
      ).queryDisabledMessage;
      if (disabledQueryMessage) {
        showSnackbar({
          title: disabledQueryMessage,
          color: 'warning',
        });
      }
    },
    [showSnackbar, getDataSourceRecord],
  );

  return { showDisabledDSMessage };
}

export default useShowDisabledDataSourceSnackbar;
